import { gql } from "@apollo/client";

export const createClassroomBookingMutation = gql`
  mutation createClassroomBooking(
    $scenarioId: ID!
    $originId: ID!
    $input: ClassroomBookingCrudInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomBookingsCrud(input: $input) {
        skippedValidations
        commited
        payload {
          creates {
            skippedValidations
            commited
            booking {
              id
            }
            validationErrors {
              __typename
              ... on InvalidInput {
                code
                __typename
              }
              ... on InvalidDate {
                start
                end
                __typename
              }
              ... on ClassroomClash {
                sessions {
                  id
                  assignment {
                    intervals {
                      id
                      name
                      startingDate
                      endingDate
                      __typename
                    }
                    blockRange {
                      start {
                        day
                        startingTime
                        __typename
                      }
                      end {
                        day
                        endingTime
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
            }
          }
          updates {
            booking {
              id
            }
          }
          deletes {
            booking {
              id
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
